import { createSlice } from '@reduxjs/toolkit';
import { performGlobalLogout } from './authSlice';

const normalizeRoundId = (value) => {
  if (value == null || value === '') return null;
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};

const initialState = {
  lastMessage: null,
  status: 'disconnected', // 'connected' | 'disconnected'
  roundId: null,
  lastCompletedRound: null,
};

const aviatorSocketSlice = createSlice({
  name: 'aviatorSocket',
  initialState,
  reducers: {
    connected(state) {
      state.status = 'connected';
    },
    disconnected(state) {
      state.status = 'disconnected';
      state.lastMessage = null;
      state.roundId = null;
      state.error = null;
    },
    messageReceived(state, action) {
      const payload = action.payload;
      if (!payload) return;

      const currentRoundId = normalizeRoundId(state.roundId);
      const incomingRoundId = normalizeRoundId(payload.roundId);

      if (currentRoundId != null && incomingRoundId != null && incomingRoundId < currentRoundId) {
        return;
      }

      state.lastMessage = payload;
      if (incomingRoundId != null) {
        state.roundId = payload.roundId;
      }
    },
    errorOccurred(state, action) {
      state.error = action.payload;
    },
    roundCompleted(state, action) {
      // Store the completed round result for round history
      // This will be stored in the aviator state
      state.lastCompletedRound = {
        roundId: action.payload.roundId,
        multiplier: action.payload.multiplier,
        crashTime: action.payload.crashTime,
        timestamp: Date.now(),
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(performGlobalLogout.fulfilled, (state) => {
        state.lastMessage = null;
        state.status = 'disconnected';
        state.roundId = null;
        state.error = null;
        state.lastCompletedRound = null;
      });
  },
});

export const { connected, disconnected, messageReceived, errorOccurred, roundCompleted } = aviatorSocketSlice.actions;
export default aviatorSocketSlice.reducer;
